// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scoped to the article form so shared CMS controls retain their own layout. */
.article-workspace {
    --article-border: #e2e8f0;
    --article-surface: #fff;
    --article-muted: #f8fafc;
    --article-text: #334155;
    padding: 12px 24px 0;
    border-radius: 12px;
    color: var(--article-text);
}
.dark .article-workspace {
    --article-border: #334155;
    --article-surface: #1e293b;
    --article-muted: #182334;
    --article-text: #e2e8f0;
}
.article-page-header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    gap: 16px;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid var(--article-border);
}
.article-header-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 7px;
    max-width: 100%;
    padding-top: 3px;
}
.article-mode-badge {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #64748b;
    font-size: 11px;
}
.dark .article-mode-badge {
    color: #94a3b8;
}
.article-metadata {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    max-width: 100%;
    gap: 0;
    padding: 4px;
    border: 1px solid var(--article-border);
    border-radius: 8px;
    background: var(--article-surface);
    box-shadow: 0 1px 2px rgb(15 23 42 / 4%);
}
.article-metadata-item {
    min-width: 0;
    padding: 2px 10px;
}
.article-metadata-item:first-child {
    padding-left: 0;
}
.article-metadata-item:last-child {
    padding-right: 0;
}
.article-metadata-item + .article-metadata-item {
    border-left: 1px solid var(--article-border);
}
.article-metadata dd {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #475569;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}
.dark .article-metadata dd {
    color: #cbd5e1;
}
.article-metadata strong {
    color: var(--article-text);
    font-weight: 700;
}
.article-metadata-label {
    color: #64748b;
    font-weight: 500;
}
.dark .article-metadata-label {
    color: #94a3b8;
}
.article-metadata dd > svg {
    width: 13px;
    height: 13px;
}
.article-metadata-status > span {
    gap: 5px;
    font-size: 11px;
    padding: 3px 8px;
}
.article-metadata-status > span::before {
    content: '';
    width: 6px;
    height: 6px;
    flex-shrink: 0;
    border-radius: 50%;
    background: currentColor;
}
@media (max-width: 700px) {
    .article-page-header {
        grid-template-columns: minmax(0, 1fr);
        gap: 12px;
    }
    .article-header-meta {
        justify-self: end;
    }
}
.article-columns {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
    align-items: start;
}
@media (min-width: 1100px) {
    .article-columns {
        grid-template-columns: minmax(0, 1fr) minmax(320px, 34%);
    }
}
.article-basic-fields {
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
    gap: 20px;
}
.article-panel {
    min-width: 0;
    border: 1px solid var(--article-border);
    border-radius: 12px;
    background: var(--article-surface);
    box-shadow: 0 1px 2px rgb(15 23 42 / 2%);
}
.article-panel-heading {
    padding: 15px 20px;
    border-bottom: 1px solid var(--article-border);
    border-radius: 12px 12px 0 0;
    background: var(--article-muted);
}
.article-panel-body {
    padding: 20px;
}
.article-workspace label:not(.sr-only),
.article-field-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.035em;
    line-height: 20px;
    text-transform: uppercase;
}
.article-field-label {
    margin-bottom: 8px;
}
.article-workspace input:not([type='file']):not([type='checkbox']),
.article-workspace textarea,
.article-workspace select {
    min-width: 0;
    max-width: 100%;
    border: 1px solid var(--article-border);
    border-radius: 7px;
    background-color: var(--article-surface);
    color: var(--article-text);
    font-size: 13px;
    line-height: 1.6;
}
.article-workspace textarea {
    width: 100%;
    padding: 10px 12px;
    resize: vertical;
}
.article-workspace input::placeholder,
.article-workspace textarea::placeholder {
    color: #94a3b8;
}
.article-workspace input:focus,
.article-workspace textarea:focus,
.article-workspace select:focus {
    outline: 2px solid #93c5fd;
    outline-offset: 1px;
    box-shadow: none;
}
.article-workspace button:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 3px;
}
.article-workspace :disabled {
    cursor: not-allowed;
}
.article-workspace fieldset:disabled input,
.article-workspace fieldset:disabled textarea,
.article-workspace fieldset:disabled select {
    background-color: var(--article-muted);
}
.article-workspace input,
.article-workspace textarea {
    scroll-margin-bottom: 110px;
}
.article-counted-field label {
    padding-right: 92px;
}
.article-field-count {
    position: absolute;
    top: 3px;
    right: 0;
    font-size: 10px;
    line-height: 16px;
    font-variant-numeric: tabular-nums;
    color: #64748b;
}
.dark .article-field-count {
    color: #94a3b8;
}
.article-slug-field {
    display: flex;
    align-items: stretch;
    min-width: 0;
}
.article-slug-prefix {
    display: flex;
    align-items: center;
    padding: 0 12px;
    border: 1px solid var(--article-border);
    border-right: 0;
    border-radius: 7px 0 0 7px;
    background: var(--article-muted);
    color: #64748b;
    font: 12px monospace;
}
.article-workspace .article-slug-field input {
    width: 100%;
    border-radius: 0 7px 7px 0;
    padding: 9px 12px;
    font-family: monospace;
}
.article-writing-panel .article-content-control {
    gap: 0;
}
.article-writing-panel .article-content-heading {
    padding: 14px 20px;
    background: var(--article-muted);
    border-radius: 12px 12px 0 0;
    border-bottom: 1px solid var(--article-border);
}
.article-writing-panel .article-content-control > * {
    margin-top: 0;
}
.article-writing-panel .ql-toolbar.ql-snow {
    padding: 12px;
    border: 0;
    border-bottom: 1px solid var(--article-border);
    border-radius: 0;
    background: var(--article-surface);
}
.article-writing-panel .ql-container.ql-snow {
    border: 0;
    border-radius: 0;
    background: var(--article-surface);
}
.article-writing-panel .ql-editor {
    min-height: 440px;
    padding: 24px;
    line-height: 1.8;
}
.article-writing-panel .article-content-stats {
    padding: 12px 20px;
    border-top: 1px solid var(--article-border);
}
.article-writing-panel .article-content-control > .text-red-500 {
    padding: 0 20px 12px;
}
.article-writing-panel .article-editor.has-error {
    outline: 1px solid #ef4444;
    outline-offset: -1px;
}
.article-seo-generate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--article-border);
}
.article-search-preview {
    padding: 14px;
    margin-top: 20px;
    background: var(--article-muted);
    border: 1px solid var(--article-border);
    border-radius: 8px;
}
.article-enrichment-space {
    display: grid;
    gap: 18px;
}
.article-ai-summary-card,
.article-enrichment-block {
    border: 1px solid var(--article-border);
    border-radius: 10px;
    background: var(--article-muted);
    padding: 16px;
}
.article-enrichment-heading {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 14px;
}
.article-enrichment-heading--compact {
    margin-bottom: 12px;
}
.article-enrichment-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    flex: 0 0 auto;
    border-radius: 8px;
    background: #dbeafe;
    color: #2563eb;
}
.dark .article-enrichment-icon {
    background: rgb(30 58 138 / 45%);
    color: #93c5fd;
}
.article-enrichment-heading h4 {
    margin: 1px 0 0;
    color: var(--article-text);
    font-size: 13px;
    font-weight: 650;
    line-height: 18px;
}
.article-enrichment-heading p {
    margin: 2px 0 0;
    color: #64748b;
    font-size: 11px;
    line-height: 17px;
}
.dark .article-enrichment-heading p {
    color: #94a3b8;
}
.article-enrichment-count {
    flex: 0 0 auto;
    color: #64748b;
    font-size: 10px;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
}
.article-takeaway-list {
    display: grid;
    gap: 8px;
}
.article-takeaway-row {
    display: flex;
    align-items: center;
    gap: 8px;
}
.article-takeaway-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    flex: 0 0 auto;
    border-radius: 50%;
    background: var(--article-surface);
    color: #64748b;
    font-size: 10px;
    font-weight: 700;
    box-shadow: inset 0 0 0 1px var(--article-border);
}
.article-enrichment-remove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    flex: 0 0 auto;
    border-radius: 6px;
    color: #dc2626;
}
.article-enrichment-remove:hover {
    background: #fee2e2;
}
.dark .article-enrichment-remove:hover {
    background: rgb(127 29 29 / 45%);
}
.article-faq-list {
    display: grid;
    gap: 10px;
}
.article-faq-card {
    border: 1px solid var(--article-border);
    border-radius: 8px;
    padding: 12px;
    background: var(--article-surface);
}
.article-faq-card-header {
    display: flex;
    min-height: 22px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    color: #64748b;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}
.article-faq-card input {
    font-weight: 600;
}
@media (max-width: 540px) {
    .article-ai-summary-card,
    .article-enrichment-block {
        padding: 12px;
    }
    .article-enrichment-heading {
        gap: 8px;
    }
    .article-enrichment-heading > button {
        padding-left: 8px;
        padding-right: 8px;
    }
}
.article-review-panel {
    border: 1px solid #fde68a;
    border-radius: 12px;
    background: #fffdf5;
    color: #92400e;
}
.article-review-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 15px 16px;
    border-bottom: 1px solid #fef3c7;
    background: #fffbeb;
    border-radius: 12px 12px 0 0;
}
.article-review-panel textarea {
    border-color: #fcd34d;
}
.dark .article-review-panel {
    background: #2a251e;
    border-color: #78552a;
    color: #fcd34d;
}
.dark .article-review-heading {
    background: #332a1b;
    border-color: #78552a;
}
.dark .article-review-panel textarea {
    border-color: #78552a;
}
.article-action-bar {
    position: sticky;
    bottom: 0;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin: 28px -24px 0;
    padding: 16px 24px;
    border-top: 1px solid var(--article-border);
    background: var(--article-surface);
    box-shadow: 0 -4px 16px rgb(15 23 42 / 3%);
}
.article-action-bar button {
    border-radius: 7px;
    font-size: 13px;
    font-weight: 500;
}
@media (max-width: 600px) {
    .article-workspace {
        padding: 10px 12px 0;
    }
    .article-basic-fields {
        grid-template-columns: minmax(0, 1fr);
        gap: 16px;
    }
    .article-panel-body {
        padding: 16px;
    }
    .article-panel-heading,
    .article-writing-panel .article-content-heading {
        padding: 14px 16px;
    }
    .article-writing-panel .ql-editor {
        min-height: 320px;
        padding: 16px;
    }
    .article-content-stats > span:first-child {
        display: none;
    }
    .article-action-bar {
        margin-right: -12px;
        margin-left: -12px;
        padding: 12px;
    }
    .article-action-bar > div {
        width: 100%;
    }
    .article-workspace input,
    .article-workspace textarea {
        scroll-margin-bottom: 160px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/containers/Protected/Articles/ArticleEditor.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;IACI,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,MAAM;IACN,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;AAC5C;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,4CAA4C;AAChD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;AACA;IACI;QACI,wDAAwD;IAC5D;AACJ;AACA;IACI,aAAa;IACb,sDAAsD;IACtD,SAAS;AACb;AACA;IACI,YAAY;IACZ,uCAAuC;IACvC,mBAAmB;IACnB,kCAAkC;IAClC,wCAAwC;AAC5C;AACA;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,4BAA4B;IAC5B,gCAAgC;AACpC;AACA;IACI,aAAa;AACjB;AACA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;;;IAGI,YAAY;IACZ,eAAe;IACf,uCAAuC;IACvC,kBAAkB;IAClB,wCAAwC;IACxC,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;IAEI,cAAc;AAClB;AACA;;;IAGI,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;;;IAGI,sCAAsC;AAC1C;AACA;;IAEI,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uCAAuC;IACvC,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,MAAM;AACV;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,4BAA4B;IAC5B,8CAA8C;AAClD;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,oBAAoB;AACxB;AACA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;;IAEI,uCAAuC;IACvC,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;AACjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,gCAAgC;IAChC,cAAc;AAClB;AACA;IACI,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iDAAiD;AACrD;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;IACb,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI;;QAEI,aAAa;IACjB;IACA;QACI,QAAQ;IACZ;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,4BAA4B;AAChC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,2CAA2C;IAC3C,kCAAkC;IAClC,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,qCAAqC;QACrC,SAAS;IACb;IACA;QACI,aAAa;IACjB;IACA;;QAEI,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;;QAEI,2BAA2B;IAC/B;AACJ","sourcesContent":["/* Scoped to the article form so shared CMS controls retain their own layout. */\n.article-workspace {\n    --article-border: #e2e8f0;\n    --article-surface: #fff;\n    --article-muted: #f8fafc;\n    --article-text: #334155;\n    padding: 12px 24px 0;\n    border-radius: 12px;\n    color: var(--article-text);\n}\n.dark .article-workspace {\n    --article-border: #334155;\n    --article-surface: #1e293b;\n    --article-muted: #182334;\n    --article-text: #e2e8f0;\n}\n.article-page-header {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: start;\n    gap: 16px;\n    padding-bottom: 16px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid var(--article-border);\n}\n.article-header-meta {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 7px;\n    max-width: 100%;\n    padding-top: 3px;\n}\n.article-mode-badge {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    color: #64748b;\n    font-size: 11px;\n}\n.dark .article-mode-badge {\n    color: #94a3b8;\n}\n.article-metadata {\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    max-width: 100%;\n    gap: 0;\n    padding: 4px;\n    border: 1px solid var(--article-border);\n    border-radius: 8px;\n    background: var(--article-surface);\n    box-shadow: 0 1px 2px rgb(15 23 42 / 4%);\n}\n.article-metadata-item {\n    min-width: 0;\n    padding: 2px 10px;\n}\n.article-metadata-item:first-child {\n    padding-left: 0;\n}\n.article-metadata-item:last-child {\n    padding-right: 0;\n}\n.article-metadata-item + .article-metadata-item {\n    border-left: 1px solid var(--article-border);\n}\n.article-metadata dd {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    color: #475569;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n.dark .article-metadata dd {\n    color: #cbd5e1;\n}\n.article-metadata strong {\n    color: var(--article-text);\n    font-weight: 700;\n}\n.article-metadata-label {\n    color: #64748b;\n    font-weight: 500;\n}\n.dark .article-metadata-label {\n    color: #94a3b8;\n}\n.article-metadata dd > svg {\n    width: 13px;\n    height: 13px;\n}\n.article-metadata-status > span {\n    gap: 5px;\n    font-size: 11px;\n    padding: 3px 8px;\n}\n.article-metadata-status > span::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background: currentColor;\n}\n@media (max-width: 700px) {\n    .article-page-header {\n        grid-template-columns: minmax(0, 1fr);\n        gap: 12px;\n    }\n    .article-header-meta {\n        justify-self: end;\n    }\n}\n.article-columns {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 24px;\n    align-items: start;\n}\n@media (min-width: 1100px) {\n    .article-columns {\n        grid-template-columns: minmax(0, 1fr) minmax(320px, 34%);\n    }\n}\n.article-basic-fields {\n    display: grid;\n    grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);\n    gap: 20px;\n}\n.article-panel {\n    min-width: 0;\n    border: 1px solid var(--article-border);\n    border-radius: 12px;\n    background: var(--article-surface);\n    box-shadow: 0 1px 2px rgb(15 23 42 / 2%);\n}\n.article-panel-heading {\n    padding: 15px 20px;\n    border-bottom: 1px solid var(--article-border);\n    border-radius: 12px 12px 0 0;\n    background: var(--article-muted);\n}\n.article-panel-body {\n    padding: 20px;\n}\n.article-workspace label:not(.sr-only),\n.article-field-label {\n    display: block;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.035em;\n    line-height: 20px;\n    text-transform: uppercase;\n}\n.article-field-label {\n    margin-bottom: 8px;\n}\n.article-workspace input:not([type='file']):not([type='checkbox']),\n.article-workspace textarea,\n.article-workspace select {\n    min-width: 0;\n    max-width: 100%;\n    border: 1px solid var(--article-border);\n    border-radius: 7px;\n    background-color: var(--article-surface);\n    color: var(--article-text);\n    font-size: 13px;\n    line-height: 1.6;\n}\n.article-workspace textarea {\n    width: 100%;\n    padding: 10px 12px;\n    resize: vertical;\n}\n.article-workspace input::placeholder,\n.article-workspace textarea::placeholder {\n    color: #94a3b8;\n}\n.article-workspace input:focus,\n.article-workspace textarea:focus,\n.article-workspace select:focus {\n    outline: 2px solid #93c5fd;\n    outline-offset: 1px;\n    box-shadow: none;\n}\n.article-workspace button:focus-visible {\n    outline: 2px solid #3b82f6;\n    outline-offset: 3px;\n}\n.article-workspace :disabled {\n    cursor: not-allowed;\n}\n.article-workspace fieldset:disabled input,\n.article-workspace fieldset:disabled textarea,\n.article-workspace fieldset:disabled select {\n    background-color: var(--article-muted);\n}\n.article-workspace input,\n.article-workspace textarea {\n    scroll-margin-bottom: 110px;\n}\n.article-counted-field label {\n    padding-right: 92px;\n}\n.article-field-count {\n    position: absolute;\n    top: 3px;\n    right: 0;\n    font-size: 10px;\n    line-height: 16px;\n    font-variant-numeric: tabular-nums;\n    color: #64748b;\n}\n.dark .article-field-count {\n    color: #94a3b8;\n}\n.article-slug-field {\n    display: flex;\n    align-items: stretch;\n    min-width: 0;\n}\n.article-slug-prefix {\n    display: flex;\n    align-items: center;\n    padding: 0 12px;\n    border: 1px solid var(--article-border);\n    border-right: 0;\n    border-radius: 7px 0 0 7px;\n    background: var(--article-muted);\n    color: #64748b;\n    font: 12px monospace;\n}\n.article-workspace .article-slug-field input {\n    width: 100%;\n    border-radius: 0 7px 7px 0;\n    padding: 9px 12px;\n    font-family: monospace;\n}\n.article-writing-panel .article-content-control {\n    gap: 0;\n}\n.article-writing-panel .article-content-heading {\n    padding: 14px 20px;\n    background: var(--article-muted);\n    border-radius: 12px 12px 0 0;\n    border-bottom: 1px solid var(--article-border);\n}\n.article-writing-panel .article-content-control > * {\n    margin-top: 0;\n}\n.article-writing-panel .ql-toolbar.ql-snow {\n    padding: 12px;\n    border: 0;\n    border-bottom: 1px solid var(--article-border);\n    border-radius: 0;\n    background: var(--article-surface);\n}\n.article-writing-panel .ql-container.ql-snow {\n    border: 0;\n    border-radius: 0;\n    background: var(--article-surface);\n}\n.article-writing-panel .ql-editor {\n    min-height: 440px;\n    padding: 24px;\n    line-height: 1.8;\n}\n.article-writing-panel .article-content-stats {\n    padding: 12px 20px;\n    border-top: 1px solid var(--article-border);\n}\n.article-writing-panel .article-content-control > .text-red-500 {\n    padding: 0 20px 12px;\n}\n.article-writing-panel .article-editor.has-error {\n    outline: 1px solid #ef4444;\n    outline-offset: -1px;\n}\n.article-seo-generate {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid var(--article-border);\n}\n.article-search-preview {\n    padding: 14px;\n    margin-top: 20px;\n    background: var(--article-muted);\n    border: 1px solid var(--article-border);\n    border-radius: 8px;\n}\n.article-enrichment-space {\n    display: grid;\n    gap: 18px;\n}\n.article-ai-summary-card,\n.article-enrichment-block {\n    border: 1px solid var(--article-border);\n    border-radius: 10px;\n    background: var(--article-muted);\n    padding: 16px;\n}\n.article-enrichment-heading {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    margin-bottom: 14px;\n}\n.article-enrichment-heading--compact {\n    margin-bottom: 12px;\n}\n.article-enrichment-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    flex: 0 0 auto;\n    border-radius: 8px;\n    background: #dbeafe;\n    color: #2563eb;\n}\n.dark .article-enrichment-icon {\n    background: rgb(30 58 138 / 45%);\n    color: #93c5fd;\n}\n.article-enrichment-heading h4 {\n    margin: 1px 0 0;\n    color: var(--article-text);\n    font-size: 13px;\n    font-weight: 650;\n    line-height: 18px;\n}\n.article-enrichment-heading p {\n    margin: 2px 0 0;\n    color: #64748b;\n    font-size: 11px;\n    line-height: 17px;\n}\n.dark .article-enrichment-heading p {\n    color: #94a3b8;\n}\n.article-enrichment-count {\n    flex: 0 0 auto;\n    color: #64748b;\n    font-size: 10px;\n    font-variant-numeric: tabular-nums;\n    font-weight: 600;\n}\n.article-takeaway-list {\n    display: grid;\n    gap: 8px;\n}\n.article-takeaway-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n.article-takeaway-number {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    flex: 0 0 auto;\n    border-radius: 50%;\n    background: var(--article-surface);\n    color: #64748b;\n    font-size: 10px;\n    font-weight: 700;\n    box-shadow: inset 0 0 0 1px var(--article-border);\n}\n.article-enrichment-remove {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    flex: 0 0 auto;\n    border-radius: 6px;\n    color: #dc2626;\n}\n.article-enrichment-remove:hover {\n    background: #fee2e2;\n}\n.dark .article-enrichment-remove:hover {\n    background: rgb(127 29 29 / 45%);\n}\n.article-faq-list {\n    display: grid;\n    gap: 10px;\n}\n.article-faq-card {\n    border: 1px solid var(--article-border);\n    border-radius: 8px;\n    padding: 12px;\n    background: var(--article-surface);\n}\n.article-faq-card-header {\n    display: flex;\n    min-height: 22px;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n    color: #64748b;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n}\n.article-faq-card input {\n    font-weight: 600;\n}\n@media (max-width: 540px) {\n    .article-ai-summary-card,\n    .article-enrichment-block {\n        padding: 12px;\n    }\n    .article-enrichment-heading {\n        gap: 8px;\n    }\n    .article-enrichment-heading > button {\n        padding-left: 8px;\n        padding-right: 8px;\n    }\n}\n.article-review-panel {\n    border: 1px solid #fde68a;\n    border-radius: 12px;\n    background: #fffdf5;\n    color: #92400e;\n}\n.article-review-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 15px 16px;\n    border-bottom: 1px solid #fef3c7;\n    background: #fffbeb;\n    border-radius: 12px 12px 0 0;\n}\n.article-review-panel textarea {\n    border-color: #fcd34d;\n}\n.dark .article-review-panel {\n    background: #2a251e;\n    border-color: #78552a;\n    color: #fcd34d;\n}\n.dark .article-review-heading {\n    background: #332a1b;\n    border-color: #78552a;\n}\n.dark .article-review-panel textarea {\n    border-color: #78552a;\n}\n.article-action-bar {\n    position: sticky;\n    bottom: 0;\n    z-index: 20;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin: 28px -24px 0;\n    padding: 16px 24px;\n    border-top: 1px solid var(--article-border);\n    background: var(--article-surface);\n    box-shadow: 0 -4px 16px rgb(15 23 42 / 3%);\n}\n.article-action-bar button {\n    border-radius: 7px;\n    font-size: 13px;\n    font-weight: 500;\n}\n@media (max-width: 600px) {\n    .article-workspace {\n        padding: 10px 12px 0;\n    }\n    .article-basic-fields {\n        grid-template-columns: minmax(0, 1fr);\n        gap: 16px;\n    }\n    .article-panel-body {\n        padding: 16px;\n    }\n    .article-panel-heading,\n    .article-writing-panel .article-content-heading {\n        padding: 14px 16px;\n    }\n    .article-writing-panel .ql-editor {\n        min-height: 320px;\n        padding: 16px;\n    }\n    .article-content-stats > span:first-child {\n        display: none;\n    }\n    .article-action-bar {\n        margin-right: -12px;\n        margin-left: -12px;\n        padding: 12px;\n    }\n    .article-action-bar > div {\n        width: 100%;\n    }\n    .article-workspace input,\n    .article-workspace textarea {\n        scroll-margin-bottom: 160px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
